import { render } from "./workflow_binding.html?vue&type=template&id=5cda1b14&external"
import script from "./workflow_binding.js?vue&type=script&lang=js&external"
export * from "./workflow_binding.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__